import React from "react";

const LongHorizontalLine = () => {
  return <div className="tw-mx-auto tw-bg-darkLine tw-h-px" />;
};

export default LongHorizontalLine;
